import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/auth',
      component: () => import('@/pages/auth/base'),
      meta: {
        authNeeded: false,
      },
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('@/pages/auth/login'),
        },
        {
          path: '/login-sso',
          name: 'login-sso',
          component: () => import('@/pages/auth/login-sso'),
        },
        {
          path: '/password_create/:token',
          name: 'set-password',
          component: () => import('@/pages/auth/password'),
          props: true
        },
        {
          path: '/tenant',
          name: 'tenant',
          component: () => import('@/pages/auth/tenant'),
        },
        {
          path: '/info',
          name: 'info',
          component: () => import('@/pages/app-info'),
        },
      ]
    },
    {
      path: '',
      component: () => import('@/pages/base'),
      meta: {
        authNeeded: true,
      },
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/pages/home'),
        },
        {
          path: '/user',
          name: 'user-list',
          component: () => import('@/pages/admin/user/list'),
        },
        {
          path: '/user/add',
          name: 'user-add',
          component: () => import('@/pages/admin/user/details'),
        },
        {
          path: '/user/:id',
          name: 'user-edit',
          component: () => import('@/pages/admin/user/details'),
          props: true
        },
        {
          path: '/statistics',
          name: 'statistics',
          component: () => import('@/pages/statistics'),
          props: true
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('@/pages/profile'),
          props: true
        },
        {
          path: '/service',
          name: 'service',
          component: () => import('@/pages/service'),
          props: true
        },
        {
          path: '/agency',
          name: 'agency-list',
          component: () => import('@/pages/admin/agency/list'),
        },
        {
          path: '/agency/add',
          name: 'agency-add',
          component: () => import('@/pages/admin/agency/details'),
        },
        {
          path: '/agency/select',
          name: 'agency-select',
          component: () => import('@/pages/admin/agency/list'),
          props: {
            isSelection: true
          }
        },
        {
          path: '/agency/:id',
          name: 'agency-edit',
          component: () => import('@/pages/admin/agency/details'),
          props: true
        },
        {
          path: '/company',
          name: 'company-list',
          component: () => import('@/pages/company/list'),
        },
        {
          path: '/company/add',
          name: 'company-add',
          component: () => import('@/pages/company/details'),
        },
        {
          path: '/company/:id',
          name: 'company-edit',
          component: () => import('@/pages/company/details'),
          props: true
        },
        {
          path: '/consultation',
          name: 'consultation-list',
          component: () => import('@/pages/consultation/list'),
        },
        {
          path: '/consultation/add',
          name: 'consultation-add',
          component: () => import('@/pages/consultation/add'),
        },
        {
          path: '/consultation/:id',
          name: 'consultation-edit',
          component: () => import('@/pages/consultation/details/index'),
          props: true
        },
        {
          path: '/rimas-light',
          name: 'rimas-light-list',
          component: () => import('@/pages/rimasLight/list'),
        },
        {
          path: '/rimas-light/add',
          name: 'rimas-light-add',
          component: () => import('@/pages/rimasLight/details'),
          props: {
            isCreation: true
          }
        },
        {
          path: '/rimas-light/:id',
          name: 'rimas-light-edit',
          component: () => import('@/pages/rimasLight/details'),
          props: {
            isCreation: false,
          }
        },
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  let timeNow = Math.floor(new Date() / 1000)
  let timeDiff = timeNow - (store.getters.lastTokenRefreshAt || 0)

  store.dispatch('setLastActionTime', timeNow)

  // refresh token if the token will be expired in 1 minutes
  if (Math.floor(timeDiff / 60) === store.getters.tokenExpireInMinutes - 1) {
    store.dispatch('refreshAuthToken')
  }

  if (!to.matched.some(record => record.meta.authNeeded)) {
    return next()
  }

  if (!store.getters.authToken || !store.getters.userTenantId || !store.getters.lastTokenRefreshAt) {
    next({
      name: 'login',
    })
  } else {
    next()
  }
})

export default router
